<template>
  <el-row class="time-picker" :gutter="6" type="flex" justify="space-between">
    <el-col v-if="includeDate">
      <el-date-picker
        v-model="date"
        type="date"
        placeholder="Pick a day"
        :picker-options="datePickerOptions"
        :value-format="'yyyy-MM-dd'"
        @change="setDate">
      </el-date-picker>
    </el-col>
    <el-col>
      <el-select v-model="hour" placeholder="Hour..." @change="setHour">
        <el-option
          v-for="(item, index) in hourOptions"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </el-col>

    <el-col>
      <el-select v-model="minute" placeholder="Minute..." @change="setMinute">
        <el-option
          v-for="(item, index) in minuteOptions"
          :key="index"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
    </el-col>

    <el-col>
      <el-select v-model="ampm" placeholder="AM/PM..." v-if="!isMilitaryTime" @change="setAmPm">
        <el-option key="AM" value="AM">AM</el-option>
        <el-option key="PM" value="PM">PM</el-option>
      </el-select>
    </el-col>
  </el-row>
</template>

<script>
  import moment from 'moment';
  import { includes, range, map } from 'lodash';

  export default {
    name: 'TimePicker',
    props: {
      value: {
        type: [Object, String, Date],
        required: true,
      },
      includeDate: {
        type: Boolean,
      },
      datePickerOptions: {
        type: Object,
      },
    },
    created() {
      const initialValue = moment(this.value);

      if (initialValue.isValid()) {
        this.date = this.value.toDate();
        this.hour = this.getHour(initialValue);
        this.minute = initialValue.format('mm');
        this.ampm = initialValue.format('A');
      }
    },
    data() {
      return {
        isMilitaryTime: !includes(moment().format('LT'), 'AM') && !includes(moment().format('LT'), 'PM'),
        date: null,
        hour: null,
        minute: null,
        ampm: null,
      };
    },
    computed: {
      hourOptions() {
        if (this.isMilitaryTime) {
          return this.getNumbers(24);
        }

        return this.getNumbers(12);
      },
      minuteOptions() {
        return this.getNumbers(59);
      },
    },
    methods: {
      setDate(value) {
        this.date = value;
        this.calculateInternalValue();
      },

      setHour(value) {
        this.hour = value;
        this.calculateInternalValue();
      },

      setMinute(value) {
        this.minute = value;
        this.calculateInternalValue();
      },

      setAmPm(value) {
        this.ampm = value;
        this.calculateInternalValue();
      },

      calculateInternalValue() {
        if (this.minute && this.hour && (!this.includeDate || (this.includeDate && this.date)) && (this.isMilitaryTime || (!this.isMilitaryTime && this.ampm))) {
          const date = this.date ? moment(this.date) : null;
          let newValue = `${this.hour}:${this.minute}`;

          if (!this.isMilitaryTime) newValue += ` ${this.ampm}`;

          const time = moment(newValue, ['h:m a', 'H:m']);

          // Date
          if (date) {
            time.year(date.year());
            time.month(date.month());
            time.date(date.date());

            this.$emit('input', time);
          // Time
          } else {
            this.$emit('input', moment(time, ['h:m a', 'H:m']).toISOString());
          }
        }
      },
      getNumbers(endNumber) {
        return map(range(0, endNumber + 1), number => this.addLeadingZero(number));
      },
      addLeadingZero(number) {
        if (number < 10) {
          return `0${number}`;
        }

        return number;
      },
      getHour(momentObj) {
        return (this.isMilitaryTime) ? momentObj.format('HH') : momentObj.format('hh');
      },
    },
    watch: {
      value(newValue) {
        if (!newValue) {
          this.date = null;
          this.hour = null;
          this.minute = null;
          this.ampm = null;
        }
      },
    },
  };
</script>

<style lang="scss">
  .time-picker {
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
      width: auto;
      min-width: 150px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/TimePicker.vue